import { IChartApi, LineSeries } from 'lightweight-charts';
import { observer } from 'mobx-react-lite';

import dayjs from 'dayjs';
import _ from 'lodash';
import { makeAutoObservable, runInAction } from 'mobx';
import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { StockIndexPriceResponse } from '../../../server/response/responseSchema';
import themeStore from '../../stores/themeStore';
import { apiClient } from '../../clientUtils/apiClient';
import { useMobxInstance } from '../../clientUtils/mobxUtil';
import StockChart, { StockChartRef } from '../chart/StockChart';
import ChangeValue from '../common/ChangeValue';

class ViewStore {
    data: StockIndexPriceResponse[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    async fetch() {
        const response = await apiClient.stockIndex.public.getValuesInRange.$query({
            ticker: '_SP500',
        });

        runInAction(() => {
            this.data = response;
        });
    }
}

const Sp500BriefCard = observer(({ className }: { className?: string }) => {
    const viewStore = useMobxInstance(ViewStore);

    const chartRef = useRef<StockChartRef>(null);

    const onChartReady = async (chart: IChartApi) => {
        await viewStore.fetch();

        const series = chart.addSeries(LineSeries, {
            lineWidth: 2,
            priceScaleId: 'right',
            color: themeStore.colors.primary,
        });

        series.setData(
            _.map(viewStore.data, (value) => ({
                time: value.date,
                value: value.value,
            })),
        );

        chart.timeScale().setVisibleLogicalRange({
            from: viewStore.data.length - 80,
            to: viewStore.data.length,
        });
    };

    const lastPoint = _.nth(viewStore.data, -1);
    const dateLabel = lastPoint ? dayjs(lastPoint?.date).format('M월 D일 ddd요일') : '';

    return (
        <div className={twMerge('flex grow flex-col', className)}>
            <div className="-mx-5">
                <StockChart ref={chartRef} onChartReady={onChartReady} />
            </div>
            <div className="mt-4">
                {lastPoint && (
                    <div className="text-base-content/80 flex flex-col text-xl">
                        <div className="text-base-content/60">{dateLabel}</div>
                        <div className="mt-5">S&P500 지수는</div>
                        <div className="mt-3">
                            <strong className="mr-2 text-3xl font-semibold">
                                {lastPoint.value?.toFixed(2)}
                            </strong>
                            포인트로
                        </div>
                        <div className="mt-3">
                            <ChangeValue
                                className="mr-2 text-3xl font-semibold"
                                value={lastPoint.dailyReturn || 0}
                                sign={true}
                                round={2}
                                suffix="%"
                            />
                            {lastPoint.dailyReturn! > 0 ? '상승' : '하락'}했습니다.
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
});

export default Sp500BriefCard;
